/**
 * Token管理工具函数
 */

/**
 * 设置token到localStorage
 * @param {string} token - 要存储的token
 */
export const setToken = (token) => {
    try {
        if (token && token !== 'undefined' && token !== 'null' && token.trim() !== '') {
            localStorage.setItem('token', token);
            console.log('Token已存储:', token);
            return true;
        } else {
            console.warn('无效的token，未存储');
            return false;
        }
    } catch (error) {
        console.error('存储token失败:', error);
        return false;
    }
};

/**
 * 从localStorage获取token
 * @returns {string|null} 返回token或null
 */
export const getToken = () => {
    try {
        const token = localStorage.getItem('token');
        if (token && token !== 'undefined' && token !== 'null' && token.trim() !== '') {
            return token;
        }
        return null;
    } catch (error) {
        console.error('获取token失败:', error);
        return null;
    }
};

/**
 * 验证token是否有效
 * @param {string} token - 要验证的token
 * @returns {boolean} token是否有效
 */
export const isValidToken = (token) => {
    return token &&
        token !== 'undefined' &&
        token !== 'null' &&
        token.trim() !== '' &&
        token.length > 0;
};

/**
 * 清除token
 */
export const clearToken = () => {
    try {
        localStorage.removeItem('token');
        console.log('Token已清除');
    } catch (error) {
        console.error('清除token失败:', error);
    }
};

/**
 * 检查用户是否已登录（基于token存在性）
 * @returns {boolean} 是否已登录
 */
export const isLoggedIn = () => {
    const token = getToken();
    return isValidToken(token);
};

/**
 * 设置用户信息和token
 * @param {Object} userData - 用户数据
 * @param {string} token - 用户token
 */
export const setUserAndToken = (userData, token) => {
    try {
        // 设置用户信息
        localStorage.setItem('user', JSON.stringify(userData));

        // 设置token
        if (setToken(token)) {
            console.log('用户信息和token已存储');
            return true;
        } else {
            console.error('token存储失败');
            return false;
        }
    } catch (error) {
        console.error('存储用户信息和token失败:', error);
        return false;
    }
};

/**
 * 清除用户信息和token
 */
export const clearUserAndToken = () => {
    try {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        console.log('用户信息和token已清除');
    } catch (error) {
        console.error('清除用户信息和token失败:', error);
    }
};
